import { useTranslation } from "react-i18next";

import { Alert, AlertDescription } from "@/components/ui/alert";

import { InfoHubReviewStep } from "../InfoHubReviewStep";
import type { InfoHubStepProps } from "../../types";

export const InfoHubMobilePreviewStep = ({ methods }: InfoHubStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-6">
      <Alert variant="warning">
        <AlertDescription>{t("infoHub.form.mobilePreviewWarning")}</AlertDescription>
      </Alert>
      <div className="h-[440px] w-[300px] overflow-y-auto rounded-2xl border-4 border-foreground/80 p-4">
        <InfoHubReviewStep methods={methods} />
      </div>
    </div>
  );
};
